import { render, staticRenderFns } from "./RenderVideo.vue?vue&type=template&id=45cf5a5c&scoped=true"
import script from "./RenderVideo.vue?vue&type=script&lang=js"
export * from "./RenderVideo.vue?vue&type=script&lang=js"
import style0 from "./RenderVideo.vue?vue&type=style&index=0&id=45cf5a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf5a5c",
  null
  
)

export default component.exports